import { PatientNote } from '@dreryk/egabinet-patient-frontend-api';

import { useTranslate } from '@dreryk/react-common';
import { SidePanelSlots } from '@dreryk/react-components';

import { notesTranslationKeys } from '../../translations';

import { StyledEmptyNoteContent } from './StyledEmptyNoteContent';

type NotesListItemContentProps = {
   readonly content: PatientNote['content'];
};

const NotesListItemContent = (props: NotesListItemContentProps): JSX.Element => {
   const translate = useTranslate();
   if (!props.content) {
      return <StyledEmptyNoteContent>{translate(notesTranslationKeys.emptyNote)}</StyledEmptyNoteContent>;
   }

   return <SidePanelSlots.Expandable>{props.content}</SidePanelSlots.Expandable>;
};

export { NotesListItemContent };
